import { useMemo } from 'react';

import type { SelectOption } from '@/shared/types';

import type { TagItem } from '@/entities/tags';
import { useAvailableTags } from '@/entities/tags/model';
import { convertTagsToTree } from '@/entities/tags/model/tagTree';

import { useUpdateGlossaryCategoryTags } from '@/features/glossary/model/useUpdateGlossaryCategoryTags';

export const useGlossaryTagsSelect = (glossaryCategoryId: string, categoryName: string, tagsList: TagItem[]) => {
  const { data: availableTags = [], isLoading: isLoadingTags } = useAvailableTags();
  const { mutateAsync: updateTags, isPending: isUpdating } = useUpdateGlossaryCategoryTags(categoryName);

  const tagsTreeData = useMemo(() => convertTagsToTree(availableTags), [availableTags]);
  const tagsValues = useMemo(() => tagsList.map((tag) => tag.tagFQN), [tagsList]);

  const tagsOptions = useMemo<SelectOption<string>[]>(
    () =>
      availableTags.map((tag) => ({
        value: tag.value,
        label: tag.label,
        displayLabel: tag.label,
        searchLabel: `${tag.label} ${tag.classification} ${tag.description}`,
      })),
    [availableTags]
  );

  const handleSaveTags = async (newTagFQNs: string[]) => {
    await updateTags({
      glossaryCategoryId,
      newTagFQNs,
      availableTags: tagsOptions,
      currentTags: tagsList,
    });
  };

  return {
    tagsTreeData,
    tagsValues,
    handleSaveTags,
    isLoading: isLoadingTags,
    isUpdating,
  };
};
